/* 
 	* 指令下发组件 
 	* 描述：InsGT740DefaultedModeSet指令下发
 	* 创建时间：2017-07-27 
 	* 创建人：baixx 
*/
<template>
	<div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label">上传间隔</label>
			    <div class="col-sm-6">
			    	<select class="form-control" v-model="uploadInterval">
						<option value="1">1</option>
						<option value="2">2</option>
						<option value="3">3</option>
						<option value="4">4</option>
						<option value="6">6</option>
						<option value="8">8</option>
						<option value="12">12</option>
						<option value="24">24</option>
						<option value="48">48</option>
						<option value="72">72</option>
						<option value="96">96</option>
						<option value="120">120</option>
						<option value="144">144</option>
						<option value="168">168</option>
						<option value="192">192</option>
						<option value="216">216</option>
						<option value="240">240</option>
						<option value="264">264</option>
						<option value="288">288</option>
						<option value="312">312</option>
						<option value="336">336</option>
						<option value="360">360</option>
					</select>
					<span  class="dis_block pt5px orange_t">单位小时</span>
			    </div> 
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label">唤醒时间</label>
			    <div class="col-sm-6">
			        <input type="text" class="form-control col-sm-1 timeD" v-model="duration" placeholder="HH:MM"> 
			    </div>
		   </div>
		   <div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px pr10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		    
		</form>
   </div>	
</template>
<script>
	export default {
		name: "InsGT740DefaultedModeSet",
		data() {
			return {
				uploadInterval:"",         //上传间隔
				duration:"",               //唤醒时间
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.uploadInterval = ''
				this.duration = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				const that = this
				if(this.uploadInterval==''){
					this.alertMsg = '请指定上传间隔'
					return
				}else{
					this.alertMsg = ''
				}
				let duration1 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.duration)
				if(duration1){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时间填写不正确'
						return
				}
				let arr = ["SETPRM","MODE",2,this.uploadInterval,this.duration]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsGT740DefaultedModeSet.vue?33a1548a